import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../Assets/Images/privateIQ2.svg';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isClubUser, setIsClubUser] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Check if user is a club user (from localStorage)
    useEffect(() => {
        const checkClubStatus = () => {
            try {
                const userProfile = localStorage.getItem('user_profile');
                if (userProfile) {
                    const profile = JSON.parse(userProfile);
                    setIsClubUser(profile.is_club === true);
                }
            } catch (e) {
                setIsClubUser(false);
            }
        };
        checkClubStatus();
    }, [location.pathname]); // Re-check when route changes

    // Pages where the ENTIRE navbar should be hidden
    const hideNavbarCompletely = ['/checkout'].includes(location.pathname);
    if (hideNavbarCompletely) return null;

    // Landing pages
    const isLandingPage = ['/', '/home', '/login', '/register'].includes(location.pathname);

    // Club dashboard pages - use minimal navbar
    const isClubDashboard = location.pathname.startsWith('/myclub/dashboard');

    // Pages where links are hidden (but logo/nav wrapper stays)
    const hiddenPages = ['/contact', '/termsofservice', '/privacypolicy', '/profile-setup', '/checkout'];
    const showNavLinks = !hiddenPages.includes(location.pathname);

    return (
        <nav className="navbar">
            <div className="navbar-logo">
                <Link to={isLandingPage ? '/home' : '/feestable'}>
                    <img src={logo} alt="PrivateIQ Logo" className="logo-image" />
                </Link>
            </div>

            {showNavLinks && (
                <>
                    <div className="navbar-toggle" onClick={toggleMenu}>
                        ☰
                    </div>
                    <ul className={`navbar-links ${isOpen ? 'show' : ''}`}>
                        {isLandingPage ? (
                            <>
                                <li>
                                    <Link to="/register" onClick={() => setIsOpen(false)}>
                                        Register
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact" onClick={() => setIsOpen(false)}>
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/login" onClick={() => setIsOpen(false)}>
                                        Login
                                    </Link>
                                </li>
                            </>
                        ) : (
                            <>
                                {isClubUser && !isClubDashboard && (
                                    <li>
                                        <Link
                                            to="/myclub/dashboard"
                                            onClick={() => setIsOpen(false)}
                                            className="dashboard-link"
                                        >
                                            Dashboard
                                        </Link>
                                    </li>
                                )}
                                <li>
                                    <Link to="/contact" onClick={() => setIsOpen(false)}>
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/logout">Logout</Link>
                                </li>
                            </>
                        )}
                    </ul>
                </>
            )}
        </nav>
    );
};

export default Navbar;
